import { apiClient } from './client';

// Permits & Engineering Tracker — API client (beta add-on).
export const listPermits = (params) => apiClient.get('/permits', { params });
export const getPermit = (id) => apiClient.get(`/permits/${id}`);
export const createPermit = (payload) => apiClient.post('/permits', payload);
export const updatePermit = (id, payload) => apiClient.patch(`/permits/${id}`, payload);
export const deletePermit = (id) => apiClient.delete(`/permits/${id}`);

export const getPermitMembers = () => apiClient.get('/permits/members');
export const getPermitOptions = () => apiClient.get('/permits/options');
export const addPermitOption = (field, value) => apiClient.post('/permits/options', { field, value });
export const getPermitThresholds = () => apiClient.get('/permits/thresholds');
export const setPermitThresholds = (payload) => apiClient.put('/permits/thresholds', payload);
export const getPermitChecklistTemplate = () => apiClient.get('/permits/checklist-template');
export const setPermitChecklistTemplate = (items) => apiClient.put('/permits/checklist-template', { items });
export const searchLinkJobs = (q = '') => apiClient.get('/permits/link-jobs', { params: { q } });

// Permit "Needs Review" intake queue (newly imported/created jobs).
export const getPermitIntake = (params) => apiClient.get('/permits/intake', { params });
export const getPermitIntakeCount = () => apiClient.get('/permits/intake/count');
export const skipPermitIntake = (jobId) => apiClient.post(`/permits/intake/${jobId}/skip`);
export const resetPermitIntake = (jobId) => apiClient.post(`/permits/intake/${jobId}/reset`);

export const addPermitNote = (id, text) => apiClient.post(`/permits/${id}/notes`, { text });
export const addInspection = (id, payload) => apiClient.post(`/permits/${id}/inspections`, payload);
export const updateInspection = (id, inspectionId, payload) =>
  apiClient.patch(`/permits/${id}/inspections/${inspectionId}`, payload);
export const deleteInspection = (id, inspectionId) =>
  apiClient.delete(`/permits/${id}/inspections/${inspectionId}`);
export const addRevision = (id, payload) => apiClient.post(`/permits/${id}/revisions`, payload);
export const deleteRevision = (id, revisionId) =>
  apiClient.delete(`/permits/${id}/revisions/${revisionId}`);

export const uploadPermitAttachment = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return apiClient.post(`/permits/${id}/attachments`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const deletePermitAttachment = (id, fileId) =>
  apiClient.delete(`/permits/${id}/attachments/${fileId}`);
